import React from "react";
import classNames from "classnames";
import WarningIcon from "@material-ui/icons/ReportProblemOutlined";
import CheckCircleIcon from "@material-ui/icons/CheckCircleOutline";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import TooltipBubble from "components/commons/tooltip/tooltip-bubble.module";
import locale from "localization";
import styles from "./shift-records-details-incomplete.module.scss";

const ShiftRecordsDetailsIncompleteCounter = ({
  count,
  isHighlighted,
  onHighlight,
  onNextField,
}) => {
  const hasIncomplete = count > 0;

  return (
    <div className={styles.floatingContainer}>
      {hasIncomplete && isHighlighted && (
        <TooltipBubble content={locale.goToNextIncompleteField}>
          <button type="button" className={styles.nextField} onClick={onNextField}>
            <KeyboardArrowDownIcon fontSize="small" />
          </button>
        </TooltipBubble>
      )}
      <TooltipBubble
        content={locale.clickToHighlightEmptyOrInvalidInputFields}
        disabled={!hasIncomplete}
      >
        <div
          className={classNames(styles.pill, { [styles.pillComplete]: !hasIncomplete })}
          onClick={hasIncomplete ? onHighlight : undefined}
        >
          {hasIncomplete ? (
            <WarningIcon className={styles.pillIcon} />
          ) : (
            <CheckCircleIcon className={styles.pillIcon} />
          )}
          {!hasIncomplete
            ? locale.allFieldsComplete
            : count === 1
              ? locale.oneFieldRemaining
              : locale.populate(locale.fieldsRemaining, [count])}
        </div>
      </TooltipBubble>
    </div>
  );
};

export default ShiftRecordsDetailsIncompleteCounter;
